import { Component, Input, EventEmitter, Output, inject, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { TextFormatComponent } from "app/components/text-format/text-format.component";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ApiService } from "app/services/api.service";
import {
  MatDialog,
} from '@angular/material/dialog';
import { ReportPipesModule } from "app/components/report/report-pipes";
import { FormsModule } from "@angular/forms";
import {
  MomentPipe,
  TransformToLangCodePipe,
  TranslateAlarmCategoryPipe,
  TranslateAlarmReasonPipe,
} from "app/pipes/pipes";
import { IAlarmReasonTranslations } from "app/models/alarm-reasons.model";
import { EventHistoryDialogComponent } from "./event-history-dialog/event-history-dialog.component";
import { HelperService } from "app/services/helper.service";

@Component({
    selector: 'app-report-alert-table',
    templateUrl: './report-alert-table.component.html',
    styleUrls: ['../../report.component.css'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [
        CommonModule,
        FormsModule,
        MatTooltipModule,
        InfiniteScrollModule,
        TextFormatComponent,
        TranslateModule,
        MomentPipe,
        TranslateAlarmReasonPipe,
        TranslateAlarmCategoryPipe,
        ReportPipesModule,
    ]
})
export class ReportAlertTableComponent {

  constructor(
    private api: ApiService,
    private helper: HelperService,
  ) { }

  @Input() alerts: any[];
  @Input() infiniteScrollDisabled: boolean;
  @Input() alarmReasonTranslations: IAlarmReasonTranslations;

  @Output() submitAlertNote = new EventEmitter<any>();
  @Output() loadNextAlerts = new EventEmitter<void>();
  @Output() openLinkedVisit = new EventEmitter<string>();

  readonly dialog = inject(MatDialog);

  submitAlertNoteHandler(alert: any): void {
    this.submitAlertNote.emit(alert);
  }

  openLinkedVisitHandler(alert: any): void {
    if (!alert?.taskId || !alert?.visitOnAlertStarted) {
      return;
    }
    this.openLinkedVisit.emit(alert.taskId);
  }

  expandRow(alert: any): void {
    alert.expanded = !alert.expanded;
  }

  shouldShowEmaTimeout(alert: any): boolean {
    return (
      alert.resolverName === 'NO_USER' && alert.deliveryType === 'EMA'
    );
  }

  getNfcTagForAlert(alert: any): string | null {
    if (alert.activationGroup === 2 && alert.activationNode === 2 && alert.emaEvents) {
      const logNewAlertEvent = alert.emaEvents.find((ema: any) => ema.eventType === 'LOG_NEW_ALERT');
      if (logNewAlertEvent) {
        return logNewAlertEvent.nfcName || logNewAlertEvent.nfcId || null;
      }
    }
    return null;
  }
  
  openDialog(alert: any): void {

    const dialogRef = this.dialog.open(EventHistoryDialogComponent, {
      data: { alert },
      maxHeight: '90vh',
    });
  }

  getActivationName(group: number, node: number, deviceId: string, deviceClass: string): string {
    const deviceType = deviceId.substring(0, 2)  + '-' + deviceClass;
    return this.helper.getActivationName(group, node, deviceType, null, 0);
  }

  sortedEmaEvents(emaEvents: any[]): any[] {
    if (!emaEvents) return [];
    return [...emaEvents].sort((a, b) => new Date(a.time).getTime() - new Date(b.time).getTime());
  }
}
